export default {
      id: "deco-titre-blanc-usage",
      viewBox: "0 0 36 21",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco-titre-blanc-usage",
      toString: function () {
        return this.url;
      }
    }